module.exports = __webpack_public_path__ + "assets/8efe9f47344ec911f16391046f219cfb.png";